module.exports = __webpack_public_path__ + "img/ambulance.1e8981d3.svg";